// extracted by mini-css-extract-plugin
export var columnItem = "_bk-3";
export var columnItemDraggable = "_bk-4";
export var dragHandle = "_bk-0";
export var dragHandleHovered = "_bk-1";
export var dropdown = "_bk-5";
export var dropdownContent = "_bk-7";
export var dropdownInner = "_bk-6";
export var filterDropdownHeader = "_bk-8";
export var icon = "_bk-2";
export var sectionDivider = "_bk-9";